import { IconButton, Box, BoxProps } from '@chakra-ui/react';
import { faToolbox } from '@fortawesome/pro-solid-svg-icons';
import { FaIcon } from '@ifixit/icons';
import { useTranslations } from '@ifixit/i18n/hooks';

interface WorkbenchIconProps {
   onClick: () => void;
}

export function WorkbenchIcon({ onClick, ...props }: WorkbenchIconProps & BoxProps) {
   const t = useTranslations('Workbench');

   return (
      <Box position="relative" {...props}>
         <IconButton
            aria-label={t('openWorkbench')}
            icon={<FaIcon icon={faToolbox} h="24px" color="white" />}
            variant="ghost"
            _hover={{ opacity: '0.7' }}
            transition="0.3s"
            _active={{
               bg: 'gray.900',
            }}
            onClick={onClick}
            id="workbenchDropdownToggle"
         />
      </Box>
   );
}
